import { Clock } from 'lucide-react';
import { format } from 'date-fns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import './CustomCalendar.scss';

export function CalendarEvent({ event }) {
  if (event.view === 'day') {
    return (
      <div className="calendar-event-day h-full">
        <div className="flex flex-col h-full px-3 py-2">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-bold text-black">{event.title}</h3>
            <span className="bg-green-50 text-green-600 text-sm px-3 py-0.5 rounded-full">
              {event.engagementGroup}
            </span>
          </div>
          <div className="text-gray-600 text-sm mt-1 flex items-center">
            <AccessTimeIcon className="mr-1" />
            {format(event.start, 'hh:mm a')}{" "}
            <span>&#8594;</span>{" "}
            {format(event.end, 'hh:mm a')}
          </div>
          <div className="text-red-500 text-sm mt-1">
            Organized by {event.username}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="calendar-event-month px-1 py-0.5">
      <div className="flex items-center gap-1">
        <div className="text-xs xl:text-xm 2xl:text-sm 3xl:text-base font-medium truncate text-gray-700">{event.title}</div>
      </div>
    </div>
  );
}